import { Table, Tag } from "antd";
import { get, isNil } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";

const PAGE_SIZE = 20;

const DISPATCHED = "SUCCESS";

const formatDate = (value) =>
  isNil(value) ? "" : new Date(value).toLocaleString();

const DispatchLogs = ({ dispatcher }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DISPATCHER);
  const [page, setPage] = useState(1);
  const logsQuery = useQuery(graphql.queries.DISPATCH_LOGS, {
    fetchPolicy: "network-only",
    variables: {
      where: { dispatcher: { id: dispatcher.id } },
      take: PAGE_SIZE,
      skip: (page - 1) * PAGE_SIZE,
    },
  });

  const columns = [
    {
      title: t("LOGS.DATE"),
      dataIndex: "createdDate",
      render: formatDate,
    },
    {
      title: t("LOGS.ROUTE"),
      dataIndex: "route",
      render: (route) => t(`ROUTE.${route}`, { defaultValue: route }),
    },
    {
      title: t("LOGS.ORGANIZATION"),
      dataIndex: "organization",
      render: (organization) => get(organization, "name", t("EMPTY_VALUE")),
    },
    {
      title: t("LOGS.STATUS"),
      dataIndex: "status",
      render: (status) =>
        status === DISPATCHED ? (
          <Tag color="green">{t("LOGS.DISPATCHED")}</Tag>
        ) : (
          <Tag color="orange">{t("LOGS.NOT_DISPATCHED")}</Tag>
        ),
    },
    {
      title: t("LOGS.URL"),
      dataIndex: "url",
      render: (url) => (isNil(url) || url === "" ? t("EMPTY_VALUE") : url),
    },
    {
      title: t("LOGS.RESPONSE"),
      key: "response",
      render: (_value, { httpStatus, durationMs }) =>
        isNil(httpStatus)
          ? t("EMPTY_VALUE")
          : `${httpStatus} · ${durationMs} ms`,
    },
    {
      title: t("LOGS.REASON"),
      dataIndex: "code",
      render: (code) =>
        isNil(code) ? "" : t(`LOGS.CODES.${code}`, { defaultValue: code }),
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={get(logsQuery, "data.dispatchLogs.data") || []}
      loading={logsQuery.loading}
      locale={{ emptyText: t("LOGS.EMPTY") }}
      pagination={{
        current: page,
        pageSize: PAGE_SIZE,
        total: get(logsQuery, "data.dispatchLogs.count", 0),
        onChange: setPage,
      }}
    />
  );
};

export default DispatchLogs;
